import { useEffect, useRef, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting.js";
import { MyTheme } from "../../colors"; // Importar los colores definidos
import { login } from "../../../../../../apis";





export const InnovaDistribution = ({ chartData, startDate, endDate }) => {
    const [chart, setChart] = useState(null);
    const chartDivId = useRef(`innovaDistibutionStateType-${Math.random().toString(36).substring(2, 11)}`); // Genera un ID único para cada gráfico
    const diaInicio = startDate
    const diaFin = endDate

    let catalogo = "";

    if (chartData.show_graphic_graphic) {
        let newCatalogo = "innline_2025";


        if (newCatalogo && newCatalogo !== catalogo) {
            catalogo = 'C::OWN::' + newCatalogo;
        }
    }


    let banner = "innovasport"

    if (chartData.isInnova){
        banner = chartData.isInnova
    }

    



    const stateReportMap = {};
    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }

    chartData.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoBanner = "unknown";
        let tipoDenuncia = "unknown";



        subArray.forEach((item) => {
            if (item.key === catalogo) {

                estado = estados[item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[3]];
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
                
                if (estado !== "none") {
                    if (estado !== "" && estado !== null && estado !== undefined) {
                        estado = capitalizeWords(estado);
                    } else {
                        estado = "unknown";
                    }
                }else{
                    estado = "unknown";
                }
            }
            
            
            if (item.key === 'C::OWN::tipo_de_reporte' || item.key === 'C::EG::RC-100' ) {
                
                tipoDenuncia = item.value.replace(/type::/g, '');
                
                tipoDenuncia = capitalizeWords(tipoDenuncia);
            }
        });

        if (estado !== "unknown") {

            if (!stateReportMap[estado]) {
                stateReportMap[estado] = {};
            }

            if (!stateReportMap[estado][tipoDenuncia]) {
                stateReportMap[estado][tipoDenuncia] = 0;
            }
            stateReportMap[estado][tipoDenuncia]++;
        }
        
    });


    useEffect(() => {
        let newChart = null;

        const generateChart = async () => {
            try {


                var startDate = new Date(diaInicio).getTime();
                var endDate = new Date(diaFin).getTime();
                const endDatePlusOneDay = new Date(endDate);
                endDatePlusOneDay.setDate(endDatePlusOneDay.getDate() + 1);


                const root = am5.Root.new(chartDivId.current);
                root.setThemes([MyTheme.new(root)]);


                var zoomableContainer = root.container.children.push(
                    am5.ZoomableContainer.new(root, {
                        width: am5.p100,
                        height: am5.p100,
                        wheelable: true,
                        pinchZoom: true
                    })
                );

                newChart = root.container.children.push(
                    am5percent.PieChart.new(root, {
                        layout: root.verticalLayout,
                    })
                );

                var series = zoomableContainer.contents.children.push(
                    am5hierarchy.Treemap.new(root, {
                        maskContent: false,
                        sort: "descending",
                        singleBranchOnly: false,
                        downDepth: 2,
                        upDepth: 0,
                        initialDepth: 2,
                        valueField: "value",
                        categoryField: "name",
                        childDataField: "children",
                        nodePaddingOuter: 0,
                        nodePaddingInner: 0
                    })
                );

                series.labels.template.setAll({
                    fill: am5.color(0x000000),
                    fontSize: 12,
                    textAlign: "center",
                    minWidth: am5.percent(100),
                    oversizedBehavior: "wrap",
                    fontWeight: "bold"
                });

                series.nodes.template.events.on("click", function (ev) {
                    var depth = ev.target.dataItem.get("depth");
                    if (depth == 2) {
                        series.selectDataItem(ev.target.dataItem.get("parent"));
                    }
                })

                series.labels.template.set("minScale", 0);
                series.get("colors").set("step", 1);


                let data = stateReportMap;

                function processData(data) {
                    var treeData = [];
                    var smallBrands = { name: "Other", children: [] };

                    for (const state in data) {
                        var brandData = { name: state, children: [] };
                        var brandTotal = 0;

                        for (const denuncia in data[state]) {
                            brandTotal += data[state][denuncia];
                        }

                        for (const denuncia in data[state]) {
                            let tipoLimpio = denuncia.replace(/type::/g, "").replace(/::/g, " ").replace(/_/g, " ");
                            
                            brandData.children.push({
                                name: `${state} / \n ${tipoLimpio}`,
                                value: data[state][denuncia],
                                fill: am5.color(0x677935),
                            });
                        }

                        if (brandTotal >= 1) {
                            treeData.push(brandData);
                        } else {
                            smallBrands.children.push(brandData);
                        }
                    }

                    if (smallBrands.children.length > 0) {
                        treeData.push(smallBrands);
                    }

                    return [{
                        name: "Root",
                        children: treeData
                    }];
                }


                series.data.setAll(processData(data));
                series.set("selectedDataItem", series.dataItems[0]);


                var exporting = am5plugins_exporting.Exporting.new(root, {
                    menu: am5plugins_exporting.ExportingMenu.new(root, {
                        align: "right",
                        valign: "bottom"
                    })
                });

                newChart.legend = am5.Legend.new(root, {});

                if (chart) {
                    chart.dispose();
                }

                setChart(newChart);
            } catch (error) {
                console.error("Error al cargar las bibliotecas de AmCharts:", error);
            }
        };

        generateChart();

        return () => {
            am5.array.each(am5.registry.rootElements, function (root) {
                if (root) {
                    if (root.dom.id == chartDivId.current) {
                        root.dispose();
                    }
                }
            });
            if (chart) {
                chart.dispose();
            }
        };
    }, [chartData, startDate, endDate]);

    return <div id={chartDivId.current} style={{ width: "100%", height: "500px" }}></div>;
};

export default InnovaDistribution;